import { useEffect } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { hideLoader, showLoader } from "../../../../store/actions";
import { getDetailsFromPincode } from "../../../../store/actions/newSubscriber";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import { setKYCBankDetails, setSkipKyc } from "../Context/NewSubscriberAction";
import { _getOptions } from "./util/getOptions";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import FormTextInput from "./lib/formik/InputField";
import FormSelectInput from "./lib/formik/inputSelectField";
import Note from "./lib/Note";
import { SUCCESS_RESPONSE_CODE } from ".";

function KYCForm({ values }) {
  const dispatch = useDispatch();
  const { popBankDetails, statesList, countriesList } =
    useNewSubscriberContext();

  const { setFieldValue } = useFormikContext();
  const country = values.country;
  const pincode = values.pincode;

  useEffect(() => {
    async function loadPincode() {
      const response = await dispatch(getDetailsFromPincode({ pincode }));
      if (+response?.statusCode === SUCCESS_RESPONSE_CODE) {
        const { data } = response;
        const { Country, District, State } = data[0];
        setFieldValue("district", District || "");
        setFieldValue("state", State || "");
        setFieldValue("country", Country || "");
      }
    }
    if (pincode && pincode.length === 6) {
      loadPincode();
    }
  }, [pincode, dispatch, setFieldValue]);

  useEffect(() => {
    !!country && country !== "IN" && setFieldValue("state", "");
  }, [country, setFieldValue]);

  const { statusCode: bankDetailsStatusCode, data: popBankData } =
    popBankDetails;
  const bankOptions =
    +bankDetailsStatusCode === SUCCESS_RESPONSE_CODE
      ? _getOptions(popBankData.ListBankName, "ID", "Value")
      : [];

  return (
    <div className="new-investor-container">
      <FormSelectInput
        label="Bank name"
        name="bank"
        required
        options={bankOptions}
      />
      <FormTextInput label="Address line 1" name="line1" required />
      <FormTextInput label="Address line 2" name="line2" required />
      <FormTextInput label="Pincode" name="pincode" required />
      <FormTextInput label="District" name="district" required />
      {values.country !== "IN" && values.country ? (
        <FormTextInput label="State / U.T" name="state" />
      ) : (
        <FormSelectInput
          label="State / U.T"
          name="state"
          required
          options={statesList}
        />
      )}
      <FormSelectInput
        label="Country"
        name="country"
        required
        options={countriesList}
      />
    </div>
  );
}
export default function Kyc() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    pan,
    kycTrack,
    dispatch: dispatchContext,
  } = useNewSubscriberContext();
  const {
    DtData: [kycKtrackDetails = {}],
  } = kycTrack;

  const initialValues = {
    pan,
    name: kycKtrackDetails?.name || "",
    bank: kycKtrackDetails?.Bankname || "",
    line1: kycKtrackDetails?.Bankadd1 || "",
    line2: kycKtrackDetails?.Bankadd2 || "",
    pincode: kycKtrackDetails?.Bankpin || "",
    district: kycKtrackDetails?.Bankcity || "",
    state: kycKtrackDetails?.Bankstate || "",
    country: kycKtrackDetails?.country || "",
  };

  const validationSchema = Yup.object({
    bank: Yup.string().required("Bank Name is required"),
    line1: Yup.string()
      .required("Address Line 1 is required")
      .matches(/^(?!\s+$).+$/, "Address cannot be empty"),
    line2: Yup.string()
      .required("Address Line 2 is required")
      .matches(/^(?!\s+$).+$/, "Address cannot be empty"),
    pincode: Yup.string()
      .required("Pincode is required")
      .matches(/^[0-9]{6}$/, "Pincode should be 6 digits"),
    state: Yup.string().required("State is required"),
    district: Yup.string().required("District is required"),
    country: Yup.string().required("Country is required"),
  });

  const _handleSubmit = async (values) => {
    try {
      dispatch(showLoader());
      const { bank, line1, line2, district, state, pincode, country, name } =
        values;
      const params = {
        BankName: bank,
        Address1: line1,
        Address2: line2,
        District: district,
        StateName: +state,
        PinCode: pincode,
        PANNumber: pan,
        CountryName: country,
        IdentifierType: 119,
        IdentifierNum: pan,
        SubscriberName: name,
      };
      dispatchContext(setKYCBankDetails(params));
      dispatchContext(setSkipKyc(false));
      history.push({
        pathname: "/nps/AddSubs/personal-details",
      });
    } catch (error) {
      alert(error);
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/new-reg",
    });
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_handleSubmit}
      >
        {({ values }) => (
          <Form>
            <div style={{ padding: "24px" }}>
              <KYCForm values={values} />
            </div>
            <Note
              list={[
                "Please select the point of Presence (POP) where you have existing relationship - either a Savings/Current account (in case of Bank) or any Demat/Mutual Fund /insurance etc. (in case of non-Bank)",
                "Your KYC verification under NPS will be done by POP(Bank / non - Bank) as KYC authentication charges.",
                "Address entered by the subscriber needs to be same as the address in the selected bank records.",
              ]}
            />
            <div className="d-flex justify-content-center">
              <button
                className="new-investor-button"
                onClick={goBack}
                disabled={!goBack}
                style={{
                  border: "1px solid #007ac8",
                  color: "#007ac8",
                }}
              >
                Back
              </button>
              <button
                type="submit"
                className="new-investor-button new-investor-active"
              >
                Proceed
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
